<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Finishing up</h5>
      <p>You're all done! Let's see your license page.</p>
      <router-link :to="{name: 'repo', params: {owner: repo.split('/')[0], repo: repo.split('/')[1]}}" class="btn btn-outline-primary">
        <i class="fas fa-arrow-right" />
        Take me there
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'End',
  props: ['repo']
}
</script>
